import cx from 'clsx';

import styles from './styles.module.scss';
import type { Component } from './types';

export const PageContentContainer: Component = ({
  children,
  className,
}) => (
  <div
    className={cx(
      styles.containerRoot,
      className,
    )}>
    {children}
  </div>
);
